<template>
  <div class="auctions-table">
    <div class="table-header">
      <h4>{{ $t("AUCTIONS.UPCOMMING_AUCTIONS") }}</h4>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      :data="items.slice(0, itemLimit)"
    >
      <el-table-column min-width="110px" prop="name" sortable>
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <a @click="viewAuction(row.id)" class="avatar rounded-circle mr-3">
              <img alt="Image placeholder" :src="row.organization_logo" />
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('AUCTIONS.NAME')" min-width="250px">
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.name
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('COMMON.ORGANIZATION')"
        min-width="250px"
        prop="name"
        sortable="custom"
      >
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.organization_name
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        min-width="200px"
        prop="start_at"
        :label="$t('COMMON.START_AT')"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        min-width="200px"
        prop="end_at"
        :label="$t('COMMON.END_AT')"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column min-width="180px">
        <template v-slot="{ row }">
          <el-dropdown trigger="click" class="dropdown">
            <span class="btn btn-sm btn-icon-only text-light">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a class="dropdown-item" @click="viewAuction(row.id)">Voir</a>
              <a class="dropdown-item" @click="editAuction(row.id)">Modifier</a>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "upcomming-auctions-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    itemLimit: {
      type: Number,
      default: 9,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    console.log(this.items);
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    viewOrganization(id) {
      this.$router.push({
        name: "List Organizations",
        query: { id: id, action: "view" },
      });
    },
    viewAuction(id) {
      this.$router.push({
        name: "List Auctions",
        query: { id: id, action: "view" },
      });
    },
    editAuction(id) {
      this.$router.push({
        name: "List Auctions",
        query: { id: id, action: "edit" },
      });
    },
  },
};
</script>
